import React, {useEffect, useState} from 'react';
import styled from 'styled-components';

const MovementDiv = styled.div<{percent: number}>`
    margin-bottom: 30px;
    display: flex;
    .image {
        width: 100px;
        height: 75px;
    }
    .info {
        width: 100%;
        > * {
            display: block;
            margin-bottom: 5px;
        }
        .progressbar {
            .progress-container {
                width: 0%;
                -webkit-transition: width 1s ease-in-out;
                -moz-transition: width 1s ease-in-out;
                -o-transition: width 1s ease-in-out;
                transition: width 1s ease-in-out;
            }
        }

        .progressbar {
            height: 20px;
            position: relative;
        }

        .progressbar span {
            display: block;
            height: 100%;
        }

        .progress {
            position: relative;
            background-color: #AEC90A;
            &:after {
                right: -13px;
                top: 50%;
                border: solid transparent;
                content: " ";
                position: absolute;
            }
            &:after {
                border-left-color: #AEC90A;
                border-width: 14.3px;
                margin-top: -24px;
                transform: rotate(-136deg);
            }
        }
    }
`;

type MovementProps = {
    alt: string;
    src: string;
    duration: number;
    percent: number;
}

export function Movement(props: MovementProps) {

    const [progress, setProgress] = useState(0);

    useEffect (() => {
        const timer = setTimeout(() => {
            setProgress(props.percent);
        }, 100);
        return () => clearTimeout(timer);
    }, [props.percent]);

    return <MovementDiv percent={props.percent} className={"ppi_column_container ppi_col-sm-12 ppi_col-md-6"}>
            <div className={"image"}>
                <img src={props.src} alt={props.alt} />
            </div>
            <div className={"info"}>
                <strong>{props.alt}</strong>
                <div className="progressbar">
                    <span className={"progress-container"} style={{width:progress + '%'}}>
                        <span className="progress"></span>
                    </span>
                </div>
                <span>ca. {props.duration} min</span>
            </div>
    </MovementDiv>
}
